import { CLIENT_ID, PERMISSIONS } from 'shared/constants';
import { AppPermission, UserInfo } from 'shared/types';

export function determineIsAdmin(user: UserInfo | null) {
  return Boolean(user?.isInsightEmployee || user?.isManager);
}

export const getAppPermissions = (InsightClaims: string) => {
  return InsightClaims.split(' ').filter(p => p.startsWith(CLIENT_ID)) as AppPermission[];
};

export const getUserInfoFromIdClaims = ({
  given_name,
  family_name,
  name,
  email,
  sub,
  InsightClaims,
}: Record<string, string>): UserInfo => {
  const permissions = getAppPermissions(InsightClaims);
  const isInsightEmployee = permissions.includes(PERMISSIONS.insight);
  const isManager = permissions.includes(PERMISSIONS.manager);
  return {
    firstName: given_name,
    lastName: family_name,
    email,
    displayName: name,
    id: sub,
    insightClaims: InsightClaims,
    isManager: isInsightEmployee || isManager,
    isInsightEmployee,
  };
};
